import React from 'react';
import { BlockTypeButton } from './BlockTypeButton';

export const createListBlockButton = ordered => {
	const blockType = ordered ? 'ordered-list-item' : 'unordered-list-item';
	const icon = ordered ? 'ol' : 'ul';
	const title = ordered ? '编号' : '列表';
	function ListBlockButton({ store, theme, disabled }) {
		return (
			<BlockTypeButton store={store} theme={theme} disabled={disabled} blockType={blockType}>
				<i className={"qa-ico-" + icon} title={title}>{icon}</i>
			</BlockTypeButton>
		);
	}
	return ListBlockButton;
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/blockStylePlugin/ListBlockButton.jsx